// services/liffService.js
// LIFF (LINE Front-end Framework) service wrapper

let liff = null;
let initialized = false;
let initPromise = null;

export function isInLineBrowser() {
  return /Line\//i.test(navigator.userAgent);
}

export function getLiffId() {
  return process.env.REACT_APP_LIFF_ID || null;
}

export async function initLiff() {
  if (initialized) return liff;
  if (initPromise) return initPromise;

  const liffId = getLiffId();
  if (!liffId) {
    console.warn('[LIFF] REACT_APP_LIFF_ID not set — LIFF unavailable');
    return null;
  }

  initPromise = (async () => {
    try {
      const liffModule = await import('@line/liff');
      liff = liffModule.default || liffModule;
      await liff.init({ liffId });
      initialized = true;
      console.log('[LIFF] Initialized successfully');
      return liff;
    } catch (err) {
      console.warn('[LIFF] init failed:', err.message);
      initPromise = null;
      return null;
    }
  })();

  return initPromise;
}

export function isLiffReady() {
  return initialized && liff !== null;
}

export function isInClient() {
  return initialized && liff && liff.isInClient();
}

export function isLiffLoggedIn() {
  return initialized && liff && liff.isLoggedIn();
}

export async function getLiffProfile() {
  if (!initialized || !liff) return null;
  return liff.getProfile();
}

export function liffLogin(redirectUri) {
  if (initialized && liff) liff.login({ redirectUri });
}

export function getLiffAccessToken() {
  return (initialized && liff) ? liff.getAccessToken() : null;
}

export function closeLiff() {
  if (initialized && liff && liff.isInClient()) liff.closeWindow();
}
